var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "offer-item grid grid-rows-[auto_1fr] p-8 border border-gray -mb-px -mx-8 w-[calc(100%+4rem)] md:ml-0 md:-mr-px md:w-full",
    },
    [
      _c("div", { staticClass: "relative overflow-hidden" }, [
        _c(
          "div",
          { staticClass: "offer-item__img aspect-square img-clip select-none" },
          [
            _c("img", {
              attrs: { src: _vm.img, alt: _vm.name, loading: "lazy" },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: _vm.img, alt: _vm.name, loading: "lazy" },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "offer-item__content relative flex flex-col md:pt-6 group",
        },
        [
          _c(
            "a",
            {
              staticClass: "absolute inset-0 text-[0px] z-10",
              attrs: { href: _vm.link },
            },
            [_vm._v(_vm._s(_vm.name))]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "offer-item__eyebrow text-sm tracking-tight" },
            [
              _vm.location
                ? _c("span", [_vm._v(_vm._s(_vm.location))])
                : _vm._e(),
              _vm._v(" "),
              _vm.area
                ? _c("span", { staticClass: "inline-block px-2 opacity-50" }, [
                    _vm._v("•"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.area
                ? _c("span", [
                    _vm._v("\n        " + _vm._s(_vm.area) + "m\n        "),
                    _c("sup", [_vm._v("2")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.rooms
                ? _c("span", { staticClass: "inline-block px-2 opacity-50" }, [
                    _vm._v("•"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.rooms
                ? _c("span", [_vm._v(_vm._s(_vm.rooms) + " Rooms")])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass:
                "offer-item__title title text-2xl mt-3 group-hover:underline duration-300",
            },
            [_vm._v(_vm._s(_vm.name))]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "offer-item__price text-sm tracking-tight mt-3 whitespace-nowrap",
            },
            [_vm._v(_vm._s(_vm.price))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "arrow-diagonal offer-item__arrow absolute bottom-0 right-0 w-[18px] h-[18px] overflow-hidden",
            },
            [
              _c("div", { staticClass: "arrow-diagonal-wrapp w-full h-full" }, [
                _c(
                  "svg",
                  {
                    staticClass:
                      "absolute w-[18px] h-[18px] translate-x-[-200%] translate-y-[-200%] group-hover:translate-x-0 group-hover:translate-y-0 duration-500 ease-basic-ease transition-transform",
                  },
                  [_c("use", { attrs: { "xlink:href": "#arrow-45" } })]
                ),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass:
                      "absolute w-[18px] h-[18px] group-hover:translate-x-full group-hover:translate-y-full duration-500 ease-basic-ease transition-transform",
                  },
                  [_c("use", { attrs: { "xlink:href": "#arrow-45" } })]
                ),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }